/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Deep_P2Inputs */

const en_diff_deep_p2 = /** @type {(inputs: Diff_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The consequence shows up when a list is reordered. Take a three element array and move the first item to the end. Nothing was added or removed, but every position now holds a different value, so the diff reports three changes. Insert one item at the front of a ten element array and you get ten reports: nine changed positions and one addition at the tail. The output is accurate about positions, and misleading if you read it as a report about items.`)
};

const ko_diff_deep_p2 = /** @type {(inputs: Diff_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`목록의 순서가 바뀔 때 그 결과가 드러납니다. 세 요소 배열에서 첫 항목을 끝으로 옮겨보세요. 추가되거나 제거된 것은 없지만 이제 모든 위치가 다른 값을 담고 있으므로 diff는 세 개의 변경을 보고합니다. 열 요소 배열의 맨 앞에 한 항목을 끼워 넣으면 열 개의 보고가 나옵니다. 아홉 개의 변경된 위치와 끝의 추가 하나입니다. 출력은 위치에 대해서는 정확하고, 항목에 대한 보고로 읽으면 오해를 부릅니다.`)
};

const ja_diff_deep_p2 = /** @type {(inputs: Diff_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストの順序が変わったときにその結果が現れます。3 要素の配列で最初の項目を末尾に移してみてください。追加も削除もありませんが、すべての位置が別の値を持つことになるので、差分は 3 件の変更を報告します。10 要素の配列の先頭に 1 項目を挿入すると 10 件の報告が出ます。9 件の変更された位置と、末尾の追加 1 件です。出力は位置については正確で、項目についての報告として読むと誤解を招きます。`)
};

/**
* | output |
* | --- |
* | "The consequence shows up when a list is reordered. Take a three element array and move the first item to the end. Nothing was added or removed, but every pos..." |
*
* @param {Diff_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_deep_p2 = /** @type {((inputs?: Diff_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_deep_p2(inputs)
	if (locale === "ko") return ko_diff_deep_p2(inputs)
	return ja_diff_deep_p2(inputs)
});